document.addEventListener("DOMContentLoaded", () => {
  const updatePrice = () => {
    const priceElement = document.querySelector(".price-item--regular .ht-money");
    if (priceElement) {
      const priceText = priceElement.getAttribute("data-ht-price-converted") || priceElement.innerText.trim();
      const currencySymbol = priceText.charAt(0);
      const price = parseFloat(priceText.replace(/[^\d.-]/g, ""));

      if (!isNaN(price)) {
        const newValue = price / 20;
        let highlightElement = document.querySelector(".price-item--regular .highlight");

        // Create highlight element if it does not exist
        if (!highlightElement) {
          highlightElement = document.createElement("span");
          highlightElement.className = "highlight";
          priceElement.appendChild(highlightElement);
        }

        // Update the highlight element with the new value
        highlightElement.textContent = `(${currencySymbol}${newValue.toFixed(2)}/treatment)`;
      }
    }
  };

  const priceContainer = document.querySelector(".price__container");
  const priceElement = document.querySelector(".price-item--regular .ht-money");

  if (priceContainer && priceElement) {
    const observer = new MutationObserver(() => {
      updatePrice();
    });

    observer.observe(priceElement, { attributes: true, attributeFilter: ['data-ht-price-converted'] });
  }

  updatePrice();
});
